import types from './types';

import {promiseAction, ActionError} from '~/misc/dispatch';
import { saveAccount , getPaymentInfoApi, payOrderApi} from '~/api/membership'
import { getHpPlanInfoApi } from '../hp/api';
export const getOrderId =  (fromData) => (dispatch, getState) => promiseAction(
  dispatch,
  getState,
  types.MEMBERSHIP_GET_ORDERID,
  saveAccount(getState, fromData)
);


export const getHpPlanInfo = (memberType) => (dispatch, getState) => {
  return promiseAction(
    dispatch,
    getState,
    types.MEMBERSHIP_GET_MEMEBR_INFO,
    getHpPlanInfoApi(getState,memberType).catch(error => {
      if (!(error instanceof HTTPError)) {
        throw error;
      }
      return error.response.json().then(body => {
        const errorMessage = body.state_message;
        throw new ActionError(errorMessage);
      });
    })
  );
}

export const getPaymentInfo = (data) => (dispatch, getState) => promiseAction(
  dispatch,
  getState,
  types.MEMBERSHIP_GET_PAYMENT_INFO,
  getPaymentInfoApi(getState, data).catch(error => {
    if (!(error instanceof HTTPError)) {
      throw error;
    }
    return error.response.json().then(body => {
      const errorMessage = body.state_message;
      throw new ActionError(errorMessage);
    });
  })
);

export const payOrderAction = (dispatch, getState, val) => promiseAction(
  dispatch,
  getState,
  types.MEMBERSHIP_PAY_ORDER,
  payOrderApi(getState, val).catch(error => {
    if (!(error instanceof HTTPError)) {
      throw error;
    }
    return error.response.json().then(body => {
      const errorMessage = body.state_message;
      throw new ActionError(errorMessage);
    });
  })
)







// WEBPACK FOOTER //
// ./src/modules/membership/actions.js